import React from "react";

import { Statistics } from "features/Statistics";
import { PageTitle } from "shared/ui";

// Chrome страницы ставится здесь, а не в фиче: заголовок — дело страницы.
const StatisticsPage = () => {
    return (
        <>
            <PageTitle>Статистика</PageTitle>
            <Statistics />
        </>
    );
};

export default StatisticsPage;
